import { useState } from 'react'
import { BackButton, Breadcrums } from '../../../Components/Shared'
import CONSTANTS, { BREADCRUMS, PAGES_ROUTES } from '../../../Constants'
import AdvanceSearchStyles from '../AdvanceSearch.module.scss'
import { useAppDispatch } from '../../../Store/Hooks'
import { useNavigate } from 'react-router-dom'
import { BreadcrumsModel, ListingServiceModal } from '../../../Models'
import ListingComponent from '../../../Components/Molecule/ListingComponent'
import { setLoader } from '../../../Store/Slice/loader.slice'
import { combineErrorMessage, handleResponse, objectToQueryString } from '../../../Helpers/Util'
import mainApiService from '../../../Services'
import { ADVANCE_SEARCH } from '../../../Constants/ApiDefinations'
import { showAlert } from '../../../Store/Slice/alert.slice'
import { Typography } from '@mui/material'
import ConfirmDialog from '../../../Components/Shared/Dialog/ConfirmDialog'
import { ADVANCED_SEARCH } from '../../../Constants/Texts'
import { logger } from '../../../Helpers'

const SavedSearchListing = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [dataCount, setDataCount] = useState(0)
  const [listData, setListData] = useState<any[]>([])
  const [pageCount, setPageCount] = useState(0)
  const [idToDelete, setIdToDelete] = useState('')
  const [itemTitle, setItemTitle] = useState('')
  const [isLoader, setIsLoader] = useState<boolean>(true)

  const getPageCount = (list: any[]) => {
    if (list.length > 0) return pageCount
    if (pageCount > 1) return pageCount - 1
    return 1
  }
  const getList = async (options: ListingServiceModal) => {
    const paramsData = objectToQueryString(options)
    setIsLoader(true)
    const requestedData: any = ADVANCE_SEARCH.SAVED_SEARCH_LIST(paramsData)
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      setDataCount(result?.data?.count)
      const tempData: any[] = []
      result?.data?.records?.forEach((ele: any) => {
        tempData.push({
          _id: ele?._id,
          name: ele?.name,
          isPinnedToDashboard: ele?.isPinnedToDashboard ? 'Yes' : 'No',
          payload: ele?.payload,
          action: (
            <button
              type='button'
              className='border-none transparent-background'
              onClick={(e) => {
                e.stopPropagation()
                setItemTitle(ele?.name)
                setIdToDelete(ele?._id)
              }}
            >
              <Typography color={'red'}>{ADVANCED_SEARCH.SAVED_SEARCH_LIST.DELETE_CTA}</Typography>
            </button>
          ),
        })
      })
      setListData(tempData)
      setIsLoader(false)
    } else if (result?.error?.responseCode === 404) {
      setDataCount(0)
      setListData([])
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    }
    setIsLoader(false)
  }
  const handleDelete = async () => {
    try {
      dispatch(setLoader(true))
      const apiRequest = ADVANCE_SEARCH.DELETE_SAVED_SEARCH(idToDelete)
      const response = await mainApiService(apiRequest)
      const { error, responseCode } = handleResponse(response)
      if (!error || responseCode === 200) {
        setIdToDelete('')
        setItemTitle('')
        const list: any[] = listData.filter((item) => item._id !== idToDelete)
        setListData(list)
        dispatch(setLoader(false))
      }
    } catch (error) {
      dispatch(showAlert([true, 'An error occurred while deleting the schedule.', 'error']))
      logger.error(error)
    } finally {
      setIdToDelete('')
      setItemTitle('')
      const list: any[] = listData.filter((item) => item._id !== idToDelete)
      getList({
        sortBy: '',
        filterCondition: '',
        searchText: '',
        filterBy: '',
        sortType: 1,
        page: getPageCount(list),
        limit: 10,
      })
      setListData(list)
    }
  }

  return (
    <div className={`${AdvanceSearchStyles.page_component}`}>
      <Breadcrums
        isMarginTop={false}
        breadcrums={BREADCRUMS?.ADVANCED_SEARCH_BREADCRUMS() as BreadcrumsModel[]}
      />
      <div className={`${AdvanceSearchStyles.back_button_advance_search}`}>
        <BackButton
          label={ADVANCED_SEARCH.SAVED_SEARCH_LIST.TITLE}
          className='col73'
          handleOnClick={() => navigate(-1)}
        />
      </div>
      <ListingComponent
        showCreateButton={false}
        showSearchField={true}
        columns={CONSTANTS.SAVED_SEARCH_LISTING_COLUMNS}
        tableRows={listData}
        dataCount={dataCount}
        isLoading={isLoader}
        searchFunction={(search, sorttype, coltype, filter, pagenumber, pagecount) => {
          setPageCount(pagenumber)
          getList({
            sortBy: sorttype && coltype,
            filterCondition: filter.filterBY,
            searchText: search,
            filterBy: filter.filterText,
            sortType: sorttype,
            page: pagenumber,
            limit: pagecount,
          })
        }}
        handleRowClick={(e) => {
          navigate(`/${PAGES_ROUTES.AdvancedSearch}/${e?._id}`)
        }}
        paginationOption={CONSTANTS.PAGINATION_OPTIONS}
      />
      <ConfirmDialog
        width={778}
        description={`${ADVANCED_SEARCH.SAVED_SEARCH_LIST.DELETE_MODAL.SUB_TITLE} <strong>${itemTitle}</strong>?`}
        onClose={() => {
          setIdToDelete('')
          setItemTitle('')
        }}
        onConfirm={() => handleDelete()}
        btn1Label={ADVANCED_SEARCH.SAVED_SEARCH_LIST.DELETE_MODAL.CANCEL_CTA}
        btn2Label={ADVANCED_SEARCH.SAVED_SEARCH_LIST.DELETE_MODAL.SUCCESS_CTA}
        btn1Color='secondary'
        btn2Color='error'
        open={idToDelete?.length > 0}
        title={ADVANCED_SEARCH.SAVED_SEARCH_LIST.DELETE_MODAL.TITLE}
        icon={'DeleteRoleIcon'}
      />
    </div>
  )
}
export default SavedSearchListing
